export default __webpack_public_path__ + "static/media/2500.521c3082.png";